import React, { useEffect, useState } from 'react';
import { Wifi, WifiOff } from 'lucide-react';

function PwaNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOnlineMessage, setShowOnlineMessage] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOnlineMessage(true);
      window.setTimeout(() => setShowOnlineMessage(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOnlineMessage(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline && !showOnlineMessage) {
    return null;
  }

  return (
    <div
      className={`fixed left-4 right-4 top-4 z-[110] mx-auto flex max-w-sm items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold shadow-lg ${
        isOnline ? 'bg-emerald-600 text-white' : 'bg-slate-900 text-white'
      }`}
      role="status"
      aria-live="polite"
    >
      {isOnline ? <Wifi size={16} /> : <WifiOff size={16} />}
      <span>{isOnline ? 'Conexion restaurada' : 'Sin conexion. Usando contenido disponible offline.'}</span>
    </div>
  );
}

export default PwaNetworkStatus;
